import { createModel } from '@rematch/core';
import { IRequestSuccess } from 'common/models';
import { IRootModel } from 'app/store';

export const global = createModel<IRootModel>()({
  state: {},
  reducers: {},
  effects: () => ({
    onSuccess<T extends IRequestSuccess>(payload: T) {
      if (payload.onSuccess) {
        payload.onSuccess();
      }
    },
  }),
});
